/**
 * @desc getItems
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(shopCode: string, body: defs.walmart.AllItemsRequest, options?: any) {
  return updateResponse(
    http(URL + `/test/getItems/${shopCode}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
